
import { Vue } from "vue-class-component";

export default class BulletPoint extends Vue {}
